import { InlineDatePicker } from 'material-ui-pickers/DatePicker';
import { InlineDateTimePicker } from 'material-ui-pickers/DateTimePicker';
import calendarIcon from '../../assets/images/admin/calendar.svg';
import calendarWhiteIcon from '../../assets/images/admin/calendar_white.svg';
import React, { Component } from 'react';
import DatePicker from 'material-ui-pickers/DatePicker/DatePicker';
import { noop } from 'lodash';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme, themeClass, THEME_WHITE } from '../../constants/styling/themes';
import moment from 'moment';

class Datepicker extends Component {
    _onChange = e => {
        this.props.onChange(e.valueOf() + e.utcOffset() * 60 * 1000, this.props.name);
    };
    _onError = () => this.props.onChange(null, this.props.name);
    _onInputChange = e => {
        if (!e.target.value.length) {
            this.props.onChange(null, this.props.name);
        } else if (!e.target.value.includes('_')) {
            const value = moment(e.target.value, 'DD/MM/YYYY HH:mm');
            value.isValid() && this.props.onChange(value.valueOf() + value.utcOffset() * 60 * 1000, this.props.name);
        }
    };
    _mask = () =>
        [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/].concat(
            this.props.timePicker ? [' ', /\d/, /\d/, ':', /\d/, /\d/] : []
        );
    _toLocalDate = time => {
        return time && time - moment(time).utcOffset() * 60 * 1000;
    };
    render() {
        const PickerComponent = this.props.timePicker ? InlineDateTimePicker : InlineDatePicker;
        return (
            <MuiThemeProvider theme={theme(this.props.theme)}>
                <PickerComponent
                    ampm={this.props.timePicker ? false : undefined}
                    className={`ckp-datepicker ${themeClass(this.props.theme)}`}
                    keyboard
                    minDate={this._toLocalDate(this.props.minDate)}
                    maxDate={this._toLocalDate(this.props.maxDate)}
                    disabled={this.props.disabled}
                    keyboardIcon={
                        <img
                            alt="Open date picker."
                            src={this.props.theme === THEME_WHITE ? calendarWhiteIcon : calendarIcon}
                        />
                    }
                    label={this.props.label}
                    value={this._toLocalDate(this.props.value)}
                    onChange={this._onChange}
                    onInputChange={this._onInputChange}
                    onError={this._onError}
                    format={`DD/MM/YYYY${this.props.timePicker ? ' HH:mm' : ''}`}
                    mask={this._mask()}
                />
            </MuiThemeProvider>
        );
    }
}

DatePicker.defaultProps = {
    onChange: noop
};

export default Datepicker;



// WEBPACK FOOTER //
// ./src/components/forms/Datepicker.js